
/* injects from baggage-loader */

/* globals CKEDITOR, Editor, _, err */
/* jshint browser: true */
'use strict';

const moduleWysiwyg = angular.module('wysiwyg.initializer', ['services.layoutEditor.insertSpace']);

moduleWysiwyg.service('Text', [
  '$timeout', '$injector', 'ns', 'insertSpace', 'blockEditDialog', '$rootScope', '$filter',
  ($timeout, $injector, ns, insertSpace, blockEditDialog, $rootScope, $filter) => {
    let Y;

    const wysiwyg = {
      params: {
        customConfig: document.baseURI + '/components/ckeditor/ckeditor_config.js',
        enterMode: 2,
        format_tags: 'h1;h2;h3;h4;h5;h6;p;div;small',
        format_small: {
          element: 'h6',
          name: 'Small',
          attributes: {
            'class': 'small'
          }
        },
        format_div: {
          element: 'div',
          name: 'Обычный'
        }
      },
      blocks: {},
      findTextBlocks: function() {
        const layoutEditor = $injector.get('layoutEditor');

        this.blocks = layoutEditor.layout.all(
          [ns.blockTextClass, ns.blockHeadline1Class, ns.blockHeadline2Class, ns.blockHeadline3Class].join(',')
        );
      },
      init: function(y) {

        Y = y;
        this.findTextBlocks();

        if (!window.CKEDITOR_BASEPATH) {
          window.CKEDITOR_BASEPATH = document.baseURI + '/components/ckeditor/';
        }

        CKEDITOR.config.allowedContent = true;
        CKEDITOR.basePath = document.baseURI + '/components/ckeditor/';
        CKEDITOR.config.language = $rootScope.currentUser.lang;
        CKEDITOR.config.skin = 'moono,' + document.baseURI + '/components/ckeditor/contents.css';
        CKEDITOR.config.removePlugins = 'language, tabletools, liststyle, contextmenu, dragdrop, basket, image, magicline, link';
        CKEDITOR.config.extraPlugins = 'fontweight,customlink,fontfamily,letterspacing,lineheight,alignment,colortext,format,fontsize,blockquote,confighelper,variable,blocksettings';
        CKEDITOR.config.placeholder = $filter('translate')('widget.text.placeholder');
        CKEDITOR.config.OpenInNewWindow = $filter('translate')('widget.text.OpenInNewWindow');
        CKEDITOR.config.forcePasteAsPlainText = true;

        let fonts = window.Editor.Instrumentations.fonts.concat(window.Editor.Instrumentations.defaultFonts);
        fonts = _.map(fonts, function(f) {
          return f.family;
        });

        CKEDITOR.config.font_names = fonts.join(';');
        CKEDITOR.config.toolbar = [{
          name: 'str',
          items: ['fontweight', 'Italic', 'Underline', 'Strike', 'customlink', 'alignment', 'ColorText', 'FontFamily', 'Format', 'FontSize', 'letterspacing', 'lineheight', 'Blockquote', 'BulletedList', 'NumberedList']
        }];

        if (Editor.mode === 'email.page.editor') {
          CKEDITOR.config.toolbar[0].items.push('ContactFields');
        }
        CKEDITOR.config.toolbar[0].items.push('blocksettings');

        this.inlineVisualEditorInit();
      },
      editBlockInit: function(block) {
        block.set('contentEditable', true);
        block.set('id', block._yuid);

        if (!CKEDITOR.instances[block._yuid]) {
          CKEDITOR.disableAutoInline = true;
          CKEDITOR.inline(block._yuid, this.params);
        }
      },
      _onChangeText: function(event) {
        if (blockEditDialog.currentBlock.widget) {
          blockEditDialog.currentBlock.widget.content = event.editor.getData();
        }
      },
      setData: function(node, contentHtml) {
        const widgetWrapper = node.one(ns.widgetWrapperClass);

        if (CKEDITOR.instances[widgetWrapper._yuid]) {
          CKEDITOR.instances[widgetWrapper._yuid].setData(contentHtml);
        } else {
          console.error('CKEDITOR instance ' + widgetWrapper._yuid + ': Not found!');
          widgetWrapper.setHTML(contentHtml);
        }
      },
      inlineVisualEditorInit: function() {
        const self = this;

        this.blocks.each(function(block) {
          block = block.one(ns.widgetWrapperClass);
          if (!block) {
            err('widget wrapper not found');
          }
          if (block) {
            self.editBlockInit(block);
          }
        });

        _.each(CKEDITOR.instances, function(index, name) {
          CKEDITOR.instances[name].on('change', self._onChangeText, self);
        });
      },
      destroy: function() {
        if (!this.blocks.each) {
          return false;
        }

        this.blocks.each(function(block) {
          block = block.one(ns.widgetWrapperClass);
          if (!block) {
            err('widget wrapper not found');
          }
          if (block) {
            block.set('contentEditable', false);
          }
        });

        _.each(CKEDITOR.instances, function(index, name) {
          CKEDITOR.instances[name].destroy();
        });
      },
      setEvents: function() {}
    };
    return wysiwyg;
  }
]);



// WEBPACK FOOTER //
// ./src/app/editor/widget_initializers/wysiwyg/wysiwyg.initializer.js